import JSBI from 'jsbi';
import { ZERO } from '../../constants';
import {
  RawRefFinancePool,
  RawRefFinanceStablePool,
  RefFinancePool,
  Reserves,
} from './types';

const filterEmptyPools = (pools: RefFinancePool[]) =>
  pools.filter((pool) => pool.shares_total_supply !== '0');

const createCorrelation = (arr1: string[], arr2: any[]) =>
  arr1.reduce((acc, curr, index) => acc.set(curr, arr2[index]), new Map());

const createReserves = (
  pool: RawRefFinancePool | RawRefFinanceStablePool
): Reserves =>
  createCorrelation(
    pool.token_account_ids,
    pool.amounts.map((a) => JSBI.BigInt(a))
  );

const createCAmountReserves = (pool: RawRefFinanceStablePool): Reserves =>
  createCorrelation(
    pool.token_account_ids,
    pool.c_amounts.map((a) => JSBI.BigInt(a))
  );

const getMostLiquidPools = (pools: RefFinancePool[]) => {
  const poolsMap = pools.reduce<Map<string, RefFinancePool[]>>((acc, pool) => {
    const tokenAccountsIds = pool.token_account_ids.sort();
    const id = `${tokenAccountsIds[0]}_${tokenAccountsIds[1]}`;

    if (acc.has(id)) {
      const savedPools = acc.get(id) || [];
      acc.set(id, [...savedPools, pool]);
    } else {
      acc.set(id, [pool]);
    }

    return acc;
  }, new Map());

  const uniqPoolsByAmounts = Array.from(poolsMap.values()).flatMap(
    (poolsByTokens) => {
      return poolsByTokens.sort((poolA, poolB) => {
        const [tokenA, tokenB] = poolA.token_account_ids;

        return JSBI.greaterThan(
          JSBI.BigInt(poolB.reserves.get(tokenA) || ZERO),
          JSBI.BigInt(poolA.reserves.get(tokenA) || ZERO)
        ) &&
          JSBI.greaterThan(
            JSBI.BigInt(poolB.reserves.get(tokenB) || ZERO),
            JSBI.BigInt(poolA.reserves.get(tokenB) || ZERO)
          )
          ? 1
          : -1;
      })[0];
    }
  );

  // console.log('uniqPoolsByAmounts', uniqPoolsByAmounts);

  return uniqPoolsByAmounts;
};

const filterMostLiquidUniqPools = (pools: RefFinancePool[]) => {
  const notEmptyPools = filterEmptyPools(pools);
  const simplePools = notEmptyPools.filter(
    (pool) => pool.pool_kind === 'SIMPLE_POOL'
  );

  const mostLiquidPools = getMostLiquidPools(simplePools);

  return mostLiquidPools;
};

export {
  createCorrelation,
  filterEmptyPools,
  createReserves,
  createCAmountReserves,
  getMostLiquidPools,
  filterMostLiquidUniqPools,
};
